module.exports = __webpack_public_path__ + "img/rotate-clockwise.8778a64a.svg";